// Polygonal room geometry. Now a 12-walled room (one wall per candidate booth,
// expert-topic billboard, or the methodology board). Shared by the room builder,
// the wall layout, and the movement clamp so they all agree on the walls.
// (Module kept named hex.ts for import stability; it's a regular 12-gon now.)

export const WALL_COUNT = 22; // 5 candidates + 13 topics + methodology + roster + 2 sponsors
export const HEX_RADIUS = 36; // circumradius: centre → vertex (bigger room)
export const WALL_HEIGHT = 6;
export const WALL_THICKNESS = 0.4;
export const HEX_APOTHEM = HEX_RADIUS * Math.cos(Math.PI / WALL_COUNT); // centre → wall midpoint
export const HEX_SIDE = 2 * HEX_RADIUS * Math.sin(Math.PI / WALL_COUNT); // wall width

export interface WallSlot {
  index: number;
  angle: number; // wall-midpoint direction from the centre
  x: number;
  z: number;
}

// Wall midpoints sit on each polygon edge.
export const WALL_SLOTS: WallSlot[] = Array.from(
  { length: WALL_COUNT },
  (_, i) => {
    const angle = Math.PI / WALL_COUNT + i * ((2 * Math.PI) / WALL_COUNT);
    return {
      index: i,
      angle,
      x: Math.cos(angle) * HEX_APOTHEM,
      z: Math.sin(angle) * HEX_APOTHEM,
    };
  },
);

// Clamp a point to the room interior, keeping `margin` from each wall — stops
// the player leaving the room.
export function clampInsideHex(
  x: number,
  z: number,
  margin: number,
): { x: number; z: number } {
  let px = x;
  let pz = z;
  const limit = HEX_APOTHEM - margin;
  for (const s of WALL_SLOTS) {
    const nx = Math.cos(s.angle);
    const nz = Math.sin(s.angle);
    const d = px * nx + pz * nz;
    if (d > limit) {
      px -= nx * (d - limit);
      pz -= nz * (d - limit);
    }
  }
  return { x: px, z: pz };
}
